import { useNavigate } from 'react-router-dom';

const ContentHeader = ({ title, subtitle, showBackButton = false }) => {

  const navigate = useNavigate();

  return (
    <div className='level'>
      <div className='level-left'>
        {showBackButton && <div className='level-item'>
          <button className='button is-normal is-outlined is-dark' onClick={() => { navigate(-1); }}>
            <span className='icon mr-1'>
              <i className='fa-solid fa-arrow-left' />
            </span>
            Back
          </button>
        </div>}
        <div className='level-item'>
          <div>
            <p className="title is-3">{title}</p>
            <p className="subtitle is-6 ">{subtitle}</p>
          </div>
        </div>
      </div>
      {/* <div className='level-right'>
        <div className='level-item'>
          <button className='button is-light' onClick={() => { }}>
            <span className='icon'>
              <i className="fa-solid fa-ellipsis-vertical" />
            </span>
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default ContentHeader;